import { render, staticRenderFns } from "./helpcenterItem.vue?vue&type=template&id=49e6a6ca&scoped=true&"
import script from "./helpcenterItem.vue?vue&type=script&lang=js&"
export * from "./helpcenterItem.vue?vue&type=script&lang=js&"
import style0 from "./helpcenterItem.vue?vue&type=style&index=0&id=49e6a6ca&lang=scss&scoped=true&"
import style1 from "./helpcenterItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6a6ca",
  null
  
)

export default component.exports